const KEY = "fas_printer_settings";
const USB_KEY = "fas_printer_usb";

export function getPrintSettings() {
  try { return { autoprint: true, drawer_kick: true, ...JSON.parse(localStorage.getItem(KEY) || "{}") }; }
  catch { return { autoprint: true, drawer_kick: true }; }
}

export function setPrintSettings(s) {
  try { localStorage.setItem(KEY, JSON.stringify(s)); } catch {}
}

export function getPairedPrinter() {
  try { return localStorage.getItem(USB_KEY) || ""; } catch { return ""; }
}

export async function pairPrinterUsb() {
  if (!navigator.usb) throw new Error("Browser ini tidak mendukung WebUSB — gunakan Chrome/Edge di PC atau Android");
  const device = await navigator.usb.requestDevice({ filters: [] });
  try { localStorage.setItem(USB_KEY, `${device.vendorId}:${device.productId}`); } catch {}
  return device.productName || `USB ${device.vendorId}:${device.productId}`;
}

// Perintah ESC/POS buka laci kasir (ESC p 0) ke printer thermal via WebUSB
export async function kickDrawer() {
  try {
    if (!navigator.usb) return false;
    const saved = getPairedPrinter();
    if (!saved) return false;
    const devices = await navigator.usb.getDevices();
    const device = devices.find((d) => `${d.vendorId}:${d.productId}` === saved);
    if (!device) return false;
    await device.open();
    if (device.configuration === null) await device.selectConfiguration(1);
    const iface = device.configuration.interfaces.find((i) => i.alternates.some((a) => a.endpoints.some((e) => e.direction === "out")));
    if (!iface) { await device.close(); return false; }
    await device.claimInterface(iface.interfaceNumber);
    const ep = iface.alternates[0].endpoints.find((e) => e.direction === "out");
    await device.transferOut(ep.endpointNumber, new Uint8Array([27, 64, 27, 112, 0, 25, 250]));
    await device.close();
    return true;
  } catch { return false; }
}
